
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { Job, Language } from '@/domains/global/models'
import axios from 'axios'

@Component
export default class JobCreateForm extends Vue {
  job: Partial<Job> = { postageRequired: false }

  @Prop({ type: Boolean, default: false })
  readonly loading!: boolean

  @Prop({ type: Boolean, default: false })
  readonly submitting!: boolean

  isLoadingTranslators = false

  languages: Language[] = []

  get isMobile () {
    return this.$vuetify.breakpoint.xsOnly
  }

  get languageId () {
    return this.job.languageId
  }

  set languageId (value: string | undefined) {
    this.job = { ...this.job, languageId: value }
  }

  get requiredRule () {
    return (value: any) => !!value || 'Value is required'
  }

  async mounted() {
    await this.getLanguages()
  }

  async getLanguages () {
    const response = await axios.get<Language[]>('/jobs/languages')
    this.languages = response.data
  }

  submit() {
    this.$emit('submit', this.job)
  }
}
